var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 7.3125H7.1875V15.1875H5.875V7.3125Z",
    fill: "#0061ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8125 7.3125H11.125V15.1875H9.8125V7.3125Z",
    fill: "#0061ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 3.375V4.6875H1.9375V17.8125C1.9375 18.1606 2.07578 18.4944 2.32192 18.7406C2.56806 18.9867 2.9019 19.125 3.25 19.125H13.75C14.0981 19.125 14.4319 18.9867 14.6781 18.7406C14.9242 18.4944 15.0625 18.1606 15.0625 17.8125V4.6875H16.375V3.375H0.625ZM3.25 17.8125V4.6875H13.75V17.8125H3.25Z",
    fill: "#0061ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 0.75H11.125V2.0625H5.875V0.75Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashV2);
export default ForwardRef;